import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { toast } from 'components/global/CUK/Toast/Toast';
import { GET_CENTER_DOCUMENT } from '../../../operations-gql/queries';
import Edition from '../Modals/EditModal';

const EditionLoader = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_CENTER_DOCUMENT, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'no-cache',
    onError: () => {
      toast.error('Une erreur est survenue lors de la récupération du document')
    }
  });

  return <Edition document={data?.document} isLoading={loading} />;
};

export default EditionLoader;
